/* eslint-disable no-useless-escape */
export const mobileInputRegex = [
  {
    country_code: '91',
    regex: /^\+91[6-9]\d{9}$/,
  },
];
